import { render, staticRenderFns } from "./OpportunitiesPhoneList.vue?vue&type=template&id=b0fc0a4e"
import script from "./OpportunitiesPhoneList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesPhoneList.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesPhoneList.vue?vue&type=style&index=0&id=b0fc0a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports